export const REGISTER_FIELD_CHANGE = 'PAYMENT_METHODS/REGISTER_FIELD_CHANGE';
export const SET_PAYMENT_METHODS = 'PAYMENT_METHODS/SET_PAYMENT_METHODS';
export const HANDLE_REGISTRATION = 'PAYMENT_METHODS/HANDLE_REGISTRATION';
export const HANDLE_UPDATE = 'PAYMENT_METHODS/HANDLE_UPDATE';
export const HANDLE_LOADING = 'PAYMENT_METHODS/HANDLE_LOADING';
export const CLEAR_REGISTRATION = 'PAYMENT_METHODS/CLEAR_REGISTRATION';
